//./Dashboard/constants/dashboardQuotes.jsx

// --- DATA: Structured quotes and themes for each day of the year ---
const monthlyThemes = {
  0: "Kickstarting the Year with Drive",
  1: "Systems, Structure, and Synergy",
  2: "Momentum and Motivation",
  3: "Collaboration and Communication",
  4: "Process Excellence",
  5: "Mid-Year Momentum",
  6: "Innovation and Growth",
  7: "Leadership and Ownership",
  8: "Systems Thinking",
  9: "Performance and Results",
  10: "Collaboration and Communication",
  11: "Reflection and Future Focus",
};

const dailyQuotes = {
  0: {
    // January
    1: "Start where you are. Use what you have. Do what you can.",
    2: "A new year means new beginnings. Let's make it count.",
    3: "Small steps every day build great results.",
    4: "Discipline is the bridge between goals and accomplishment.",
    5: "Work smart, stay humble, grow daily.",
    6: "You don't have to be great to start, but you have to start to be great.",
    7: "Time spent planning saves time executing.",
    8: "Be the reason your team feels energized to show up.",
    9: "Keep showing up. Consistency outpaces intensity.",
    10: "New ideas require new actions.",
    11: "You win by staying focused when others give up.",
    12: "Every goal starts with a single action.",
    13: "Your effort compounds—don't quit now.",
    14: "Courage is showing up without knowing the outcome.",
    15: "Energy flows where attention goes.",
    16: "Change is uncomfortable, but so is staying stuck.",
    17: "A routine fuels your growth.",
    18: "Set the tone, don't wait for it.",
    19: "Own your calendar or it owns you.",
    20: "If not now, when? If not you, who?",
    21: "Focus is a competitive advantage.",
    22: "Your future self will thank you for today's effort.",
    23: "The right mindset is your best strategy.",
    24: "Everything you want is on the other side of effort.",
    25: "Let your habits speak louder than your goals.",
    26: "Discipline is choosing between what you want now and what you want most.",
    27: "Done is better than perfect.",
    28: "Start the day with intention, end it with reflection.",
    29: "Don't overthink—execute.",
    30: "When in doubt, take the next step.",
    31: "A powerful year starts with a powerful January.",
  },
  1: {
    // February
    1: "Great processes create great outcomes.",
    2: "A system is only as strong as its weakest link—optimize everything.",
    3: "Efficiency isn't about speed—it's about accuracy with purpose.",
    4: "Systems set you free to be creative.",
    5: "Structured work creates scalable success.",
    6: "If you can't measure it, you can't improve it.",
    7: "Automation empowers people, not replaces them.",
    8: "Build systems that support excellence every day.",
    9: "Complexity is the enemy of execution—simplify.",
    10: "Don't chase success—design it into your workflow.",
    11: "Consistency in systems builds trust.",
    12: "Every team needs rhythm, routine, and review.",
    13: "Repeatable systems build predictable results.",
    14: "Checklists save time and reduce errors.",
    15: "SOPs aren't bureaucracy—they're freedom.",
    16: "Great teams rely on great systems.",
    17: "Design your process to minimize friction.",
    18: "Workflows are the backbone of scale.",
    19: "Structure breeds stability, not rigidity.",
    20: "Clear processes reduce burnout.",
    21: "Documentation is delegation in disguise.",
    22: "Operations run the mission.",
    23: "Fix the process, not just the person.",
    24: "Let systems catch mistakes before people do.",
    25: "Build once. Improve always.",
    26: "Clarity in process leads to clarity in outcomes.",
    27: "Precision is productivity.",
    28: "Do it right the first time—save time later.",
  },
  2: {
    // March
    1: "Motivation gets you going, but habits keep you growing.",
    2: "The reward for good work is more responsibility—wear it with pride.",
    3: "Your energy introduces you before you speak.",
    4: "Momentum is built one completed task at a time.",
    5: "Burnout isn't from working too much, but from meaning too little.",
    6: "Your work has value—remind yourself why.",
    7: "Start fast, finish stronger.",
    8: "There is no finish line in learning.",
    9: "The best view comes after the hardest climb.",
    10: "Show up with purpose, not pressure.",
    11: "You're one good habit away from a breakthrough.",
    12: "Fuel your body, mind, and goals every day.",
    13: "Work with joy. Hustle with heart.",
    14: "Be your own source of motivation.",
    15: "What you do today becomes your momentum tomorrow.",
    16: "Forward is forward, no matter how small.",
    17: "Motivation fades. Purpose sustains.",
    18: "Let momentum carry you through resistance.",
    19: "A motivated team moves mountains.",
    20: "Celebrate the small wins—they compound.",
    21: "Motion beats meditation when you're stuck.",
    22: "Progress is invisible until it compounds.",
    23: "Next year begins in your mind before the calendar.",
    24: "Choose growth over comfort.",
    25: "End-of-year effort defines next year's start.",
    26: "Work is not just what we do, but who we become.",
    27: "In every task, sow excellence.",
    28: "Finish the year with intention.",
    29: "Take time to recognize how far you've come.",
    30: "You showed up. You gave your best. That's success.",
    31: "Momentum is created—not waited for.",
  },
  3: {
    // April
    1: "Great teams communicate clearly, consistently, and compassionately.",
    2: "Every voice matters. Inclusion builds innovation.",
    3: "Collaboration isn't a meeting; it's a mindset.",
    4: "Clarity in communication prevents chaos in execution.",
    5: "Listen to understand, not to reply.",
    6: "Strong teams listen twice as much as they speak.",
    7: "Feedback is a gift, not a grievance.",
    8: "Communication is the heartbeat of culture.",
    9: "Teamwork divides the task and multiplies the success.",
    10: "Nothing builds trust faster than transparency.",
    11: "Communication breaks silos.",
    12: "One honest conversation can shift an entire outcome.",
    13: "Meetings should inform, align, and energize.",
    14: "Ask more, assume less.",
    15: "Collaboration means combining strengths.",
    16: "Constructive conflict builds clarity.",
    17: "Good communication eliminates unnecessary stress.",
    18: "Culture is built in everyday conversations.",
    19: "Speak with intention. Respond with respect.",
    20: "Openness creates psychological safety.",
    21: "Your growth is the best investment you'll ever make.",
    22: "Win the moment, and the day takes care of itself.",
    23: "The difference between good and great is follow-through.",
    24: "Focus on impact, not just input.",
    25: "Be better today than yesterday—that's success.",
    26: "People remember how you made them feel—lead with that.",
    27: "Set the tone. Set the standard.",
    28: "Progress is a practice.",
    29: "Your attention decides your outcomes.",
    30: "Culture lives in small moments.",
  },
  4: {
    // May
    1: "Excellence is not an act but a habit of following the process.",
    2: "Don't just fix problems—fix the system that caused them.",
    3: "Consistency beats occasional brilliance.",
    4: "Master the routine that fuels high performance.",
    5: "Every repeatable result came from a repeatable process.",
    6: "Refine, revisit, repeat.",
    7: "Excellence demands intention and iteration.",
    8: "Better process equals better results.",
    9: "Improvise only after you've mastered the method.",
    10: "A simple process is better than a brilliant guess.",
    11: "Results are the outcome of process, not pressure.",
    12: "Refinement beats reinvention.",
    13: "Document the process. Then optimize it.",
    14: "A well-run process saves hundreds of decisions.",
    15: "Process is the language of professional execution.",
    16: "Be process-driven, not personality-dependent.",
    17: "Improvements come from asking: what can we do better?",
    18: "Excellence starts where excuses end.",
    19: "Don't break the system—build a better one.",
    20: "Make your process stronger than your problems.",
    21: "Better systems, better sanity.",
    22: "You shape culture with every decision.",
    23: "What you plant today, you grow tomorrow.",
    24: "Build habits. Build legacy.",
    25: "Your daily attitude is a strategy.",
    26: "Keep rising, even if it's quietly.",
    27: "Align your energy with your goals.",
    28: "Focus is your superpower.",
    29: "Make momentum your default.",
    30: "Great years are built one good day at a time.",
    31: "Drive change by embodying it.",
  },
  5: {
    // June
    1: "Evaluate, refine, and re-engage—this is how teams evolve.",
    2: "Half the year is gone—what have you built?",
    3: "Now is the time to double down, not slow down.",
    4: "Let progress, not perfection, be your guide.",
    5: "Push through the plateau—momentum is on the other side.",
    6: "Mid-year is check-in time, not check-out time.",
    7: "You've come this far. Don't stop now.",
    8: "Reset your focus, not your ambition.",
    9: "Excellence compounds across months.",
    10: "Momentum loves mid-year course correction.",
    11: "June is a fresh start for second-half goals.",
    12: "Review. Refocus. Relaunch.",
    13: "Don't slow your pace when you're tired, stop when you're done.",
    14: "Your pace doesn't matter. Just don't stop.",
    15: "Success is a series of small wins added together.",
    16: "Mid-year is where professionals pivot and rise.",
    17: "Momentum thrives on awareness.",
    18: "Stay the course, trust the process.",
    19: "Your best results may be just ahead.",
    20: "Momentum is a choice made daily.",
    21: "Refuse to coast—keep building.",
    22: "Halfway done means halfway to great.",
    23: "Mid-year is not halfway done; it's halfway ready.",
    24: "Momentum builds when you stop doubting and start doing.",
    25: "Don't slow down—refocus and finish stronger.",
    26: "June is your second chance to own the year.",
    27: "The best breakthroughs happen after the midway burnout.",
    28: "Revise your goals, not your grit.",
    29: "Every step forward in June echoes into December.",
    30: "Mid-year is proof that time rewards action.",
  },
  6: {
    // July
    1: "Innovation starts with asking better questions.",
    2: "If you never try, you'll never know.",
    3: "Growth happens when you challenge your limits.",
    4: "Mistakes are proof that you're innovating.",
    5: "Learn fast. Fail smarter. Move forward.",
    6: "Creativity thrives in curious minds.",
    7: "Comfort zones kill innovation.",
    8: "Progress begins where excuses end.",
    9: "If it't challenge you, it won't change you.",
    10: "Think different. Act boldly.",
    11: "Don't wait for opportunity—build it.",
    12: "Growth requires risk—and courage.",
    13: "Innovation rewards persistence, not perfection.",
    14: "Big change starts with brave ideas.",
    15: "Evolve or dissolve—keep growing.",
    16: "Challenge the standard to change the future.",
    17: "What you outgrow reveals who you are becoming.",
    18: "The more you learn, the more you grow.",
    19: "Ideas become reality when followed by action.",
    20: "Stagnation is the enemy of excellence.",
    21: "Growth doesn't knock—July is when you build the door.",
    22: "Innovation begins when comfort ends.",
    23: "July is your lab—test boldly, fail smart, grow fast.",
    24: "You don't need more time. You need more bold ideas.",
    25: "When routine gets too quiet, it's time to disrupt and evolve.",
    26: "The seeds of change grow best in uncertain seasons.",
    27: "Innovation isn't about genius—it's about courage and follow-through.",
    28: "Growth favors the team that experiments more than it explains.",
    29: "Don't wait for the perfect tool—create with what you have.",
    30: "Every stagnant system invites a better one to be born.",
    31: "True growth is doing what you've never done, even if it risks failing.",
  },
  7: {
    // August
    1: "Lead by example, not by instruction.",
    2: "Ownership means doing it even when no one's watching.",
    3: "Empower others and you multiply your impact.",
    4: "True leadership is rooted in service.",
    5: "Take initiative—leaders don't wait to be asked.",
    6: "Lead from every seat you sit in.",
    7: "Responsibility isn't a burden—it's your edge.",
    8: "Be the leader you once needed.",
    9: "Great leaders build more leaders.",
    10: "Don't blame. Build.",
    11: "Leadership is about making others better.",
    12: "Step up, even when it's not your job.",
    13: "Leaders listen louder than they speak.",
    14: "Courage is the foundation of leadership.",
    15: "Own your outcomes. Lead your growth.",
    16: "Responsibility turns pressure into progress.",
    17: "Influence is earned through trust.",
    18: "Leadership is action, not a title.",
    19: "Decide, commit, lead.",
    20: "Your attitude sets the tone for the whole team.",
    21: "Leadership is less about control, more about clarity and courage.",
    22: "Ownership is doing the right thing—even when no one's watching or asking.",
    23: "The best leaders don't have all the answers; they ask better questions.",
    24: "August reminds us: Lead by example, not by exception.",
    25: "Real leaders take blame, give credit, and build trust.",
    26: "Ownership means seeing the problem as yours, even when it isn't.",
    27: "When everyone takes ownership, no one is left behind.",
    28: "Leadership begins when you choose service over status.",
    29: "The quietest leader often drives the strongest momentum.",
    30: "True leaders create leaders, not followers.",
    31: "Take initiative. Lead where there's a gap—not a title.",
  },
  8: {
    // September
    1: "See the whole system—only then can you change it.",
    2: "Fix the process, not just the symptom.",
    3: "Good systems make average people achieve extraordinary things.",
    4: "A clear process reduces confusion and error.",
    5: "Optimize, don't overload.",
    6: "Systems create freedom, not rigidity.",
    7: "The system you build is the future you scale.",
    8: "Every bottleneck reveals a design flaw.",
    9: "You don't rise to goals—you fall to systems.",
    10: "A good system outlasts great intentions.",
    11: "Small tweaks in a system make a big difference.",
    12: "Great outcomes come from great workflows.",
    13: "Design your environment for success.",
    14: "Systemic clarity reduces team fatigue.",
    15: "No system? Expect chaos.",
    16: "Systems thinking turns fire-fighting into flow.",
    17: "Your system is your strategy in motion.",
    18: "Smart systems scale silently.",
    19: "Processes create predictability.",
    20: "A weak process sabotages strong people.",
    21: "Fixing people doesn't work—fix the system, and people thrive.",
    22: "A great system removes guesswork, not human spirit.",
    23: "Chaos repeats when systems are left to chance.",
    24: "September is for stepping back to zoom forward.",
    25: "Don't just solve problems—solve how problems are created.",
    26: "Systems thinking: where the real bottleneck gets exposed, not blamed.",
    27: "A good plan solves today. A good system prevents tomorrow's fire.",
    28: "When outcomes are messy, it's usually the process that's unclear.",
    29: "If you want to scale excellence, systemize what works and simplify what doesn't.",
    30: "Great systems don't just support work—they shape culture.",
  },
  9: {
    // October
    1: "Focus on outcomes, not just activity.",
    2: "Effort is the engine, results are the road.",
    3: "Work smarter—and then work consistently.",
    4: "Measure what matters, improve what counts.",
    5: "What gets tracked gets better.",
    6: "High performance is built on daily habits.",
    7: "Set clear targets. Show clearer progress.",
    8: "Your work speaks when you stay consistent.",
    9: "Excellence is not an act, but a habit.",
    10: "Performance without purpose is burnout.",
    11: "Push past average. Perform with intent.",
    12: "Effort is invisible—until the result shows.",
    13: "Daily discipline drives long-term success.",
    14: "Your results reflect your routines.",
    15: "Show up. Step up. Stand out.",
    16: "Don't just meet expectations—reset them.",
    17: "Accountability is the foundation of performance.",
    18: "Performance isn't louder—just clearer, sharper, and steadier.",
    19: "Strong performance builds strong trust.",
    20: "Consistency compounds into greatness.",
    21: "Performance is the echo of preparation, focus, and follow-through.",
    22: "October rewards those who don't just plan—but perform with precision.",
    23: "Your results are speaking—make sure they're saying the right story.",
    24: "Momentum multiplies when discipline meets direction.",
    25: "High performance is not hustle—it's habit, sharpened daily.",
    26: "Don't just chase results—build systems that attract them.",
    27: "Excellence is when effort becomes consistent, not occasional.",
    28: "What gets measured gets improved. What gets ignored gets repeated.",
    29: "If the outcome matters, so should the process that leads to it.",
    30: "Results rise when distractions fall.",
    31: "October is for raising standards, not just meeting expectations.",
  },
  10: {
    // November
    1: "Collaboration wins over competition.",
    2: "Clear is kind—be honest, be direct.",
    3: "Speak to connect, not just to be heard.",
    4: "Strong teams thrive on open dialogue.",
    5: "Feedback is a gift—give it with care.",
    6: "Collaboration is how ideas evolve.",
    7: "The best ideas are built together.",
    8: "Listen more. Assume less.",
    9: "A culture of communication drives trust.",
    10: "Great teams ask better questions.",
    11: "Speak with clarity. Listen with empathy.",
    12: "Shared goals foster deeper collaboration.",
    13: "Trust grows where transparency flows.",
    14: "Teams don't fail—communication does.",
    15: "Align first. Act fast.",
    16: "Celebrate the 'we,' not just the 'me.'",
    17: "Your tone builds—or breaks—trust.",
    18: "Collaboration is the heartbeat of great execution.",
    19: "Talk less. Connect more.",
    20: "Strong teams talk about tough things.",
    21: "Collaboration thrives when credit is shared and blame is not.",
    22: "The most effective meetings are built on listening, not just talking.",
    23: "Teamwork isn't about being right—it's about getting it right together.",
    24: "Every unspoken assumption is a future misunderstanding.",
    25: "Feedback isn't criticism—it's a contribution.",
    26: "Clear communication is kind. Ambiguity is expensive.",
    27: "A team that talks together, wins together.",
    28: "Transparency is the secret ingredient of trusted teams.",
    29: "When intentions are good, but clarity is missing, results still suffer.",
    30: "Collaboration fails in silence. Speak up, even if it's uncomfortable.",
  },
  11: {
    // December
    1: "Look back to learn. Look forward to lead.",
    2: "Your progress deserves reflection.",
    3: "Celebrate the wins—big or small.",
    4: "Every ending fuels a fresh beginning.",
    5: "Reflection builds resilience.",
    6: "Growth begins with awareness.",
    7: "Make space for thinking.",
    8: "Lessons learned today lead tomorrow.",
    9: "Finish strong. Start sharper.",
    10: "A wise team learns before leaping.",
    11: "Momentum needs maintenance.",
    12: "Your mindset sets your next season.",
    13: "Thank the past. Prepare for the future.",
    14: "Reflection makes room for reinvention.",
    15: "Evaluate. Evolve. Elevate.",
    16: "Rest, recharge, and reset with purpose.",
    17: "Use the past to fuel the plan.",
    18: "Growth isn't seasonal—mindset is.",
    19: "Purposeful pause leads to powerful progress.",
    20: "Close the year with clarity.",
    21: "Great years don't happen. They're created.",
    22: "What you do today writes your tomorrow.",
    23: "Reflection fuels next-level strategy.",
    24: "Don't end the year busy. End it better.",
    25: "Lead the future by learning from the past.",
    26: "Every lesson is a ladder. Climb it.",
    27: "Year-end is your pivot point.",
    28: "Purpose gives your next year power.",
    29: "Clarity turns chaos into focus.",
    30: "Make every day count—especially the last ones.",
    31: "A new beginning hides in every ending.",
  },
};

export { monthlyThemes, dailyQuotes };
